var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeIconRegular = function SvgEyeIconRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    stroke: "#999",
    strokeWidth: 0.5,
    d: "M10 1c3.66 0 6.906 2.873 8.922 5.756a.423.423 0 0 1 0 .488C16.906 10.127 13.659 13 10 13c-3.66 0-6.907-2.876-8.923-5.76a.422.422 0 0 1 0-.487C3.093 3.87 6.34 1 10 1Zm0 .833c-2.779 0-5.29 1.89-7.136 4.01-.58.665-.58 1.65 0 2.314 1.847 2.118 4.358 4.01 7.136 4.01 2.777 0 5.288-1.892 7.135-4.01.58-.665.58-1.65 0-2.314-1.846-2.12-4.357-4.01-7.135-4.01Zm0 2.25c1.576 0 2.863 1.311 2.863 2.917 0 1.606-1.287 2.917-2.863 2.917-1.577 0-2.864-1.311-2.864-2.917 0-1.606 1.287-2.917 2.864-2.917Zm0 .834c-1.135 0-2.046.927-2.046 2.083 0 1.156.911 2.083 2.046 2.083 1.134 0 2.045-.927 2.045-2.083 0-1.156-.911-2.083-2.045-2.083Z"
  })));
};
export default SvgEyeIconRegular;